<template>
  <div>
    <div class="selectDept">
      <van-nav-bar title="选择单位" left-text left-arrow @click-left="leftclick"/>

      <div class="selectDept_body">
        <div class="selectDept_body_h">
          <input type="text" placeholder="请输入单位关键词" v-model="searchText"/>
          <img src="../assets/img/search.png" alt/>
          <span @click="searchText = ''">取消</span>
        </div>
        <div class="selectDept_body_b">
          <div v-for="(item,index) in filterDept" :key="index" @click="btn(item)">
            <span>【{{ item.deptId }}】{{ item.deptName }}</span>
            <!-- <span>{{item.deptName}}</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {Notify} from "vant"

export default {
  name: "selectDept",
  data() {
    return {
      deptList: [],
      searchText: ""
    }
  },
  computed: {
    filterDept() {
      return this.deptList.filter((p) => {
        return p.searchText.indexOf(this.searchText) !== -1
      })
    }
  },
  created() {
    let {userName} = this.$route.query
    this.getdata(userName)
  },
  methods: {
    leftclick() {
      this.$router.back()
    },
    btn(item) {
      this.request({
        url: "/user/getAuthSwitch",
        method: "post",
        params: {deptId: item.deptId}
      }).then((res) => {
        if (res.data.code == 1000) {
          localStorage.setItem('switchvde',item.deptId)
          Notify({type: "success", message: "切换成功"})
          setTimeout(() => {
            sessionStorage.setItem("activeNum", 1)
            sessionStorage.setItem("isTyType", '1')
            this.$router.back()
          }, 2000)
        } else {
          let str = '确认'
          if (res.data.errorMessage) {
            str = '查看错误详情'
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message,
            }).then(() => {
              this.$CTips({
                title: '错误提示',
                message: res.data.errorMessage,
                clickOverlay: false
              })
            });
          } else {
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message,
            })
          }

        }
      })
    },
    getdata(userName) {
      this.request({
        url: "/userAuth/dept/getDeptListsByUserName",
        method: "get",
        params: {
          userName
        }
      }).then((res) => {
        this.deptList = res.data.result
        this.deptList.map((item) => {
          item.searchText = item.deptId + item.deptName
        })
      })

    }
  }
}
</script>

<style lang="scss">
.selectDept {
  .van-nav-bar .van-icon {
    color: #666 !important;
  }

  .van-nav-bar__title {
    font-family: PingFangSC-Semibold;
    font-size: 17px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    font-weight: 600;
  }

  .selectDept_body {
    height: calc(100vh - 78px);
    background: #f1f1f1;
    padding: 10px 15px 20px 15px;
  }

  .selectDept_body_h {
    height: 36px;
    margin-bottom: 14px;
    overflow: hidden;
    position: relative;

    img {
      width: 18px;
      height: 18px;
      position: absolute;
      top: 10px;
      left: 10px;
    }

    input {
      height: 36px;
      width: 86%;
      border-radius: 10px;
      text-indent: 44px;

      font-size: 13px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
    }

    span {

      color: #464a4c;
      font-size: 14px;
      margin-left: 10px;
    }
  }

  .selectDept_body_b {
    border-radius: 10px;
    overflow-y: auto;
    background: #fff;
    height: calc(100% - 46px);

    div {
      // height: 26px;
      display: flex;
      padding: 12px 0;
      margin: 0 20px;
      border-bottom: 1px solid #eeeeee;

      span {

        font-size: 16px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 400;
        line-height: 22px;
        word-break: break-all;
        text-indent: -6px;
      }
    }
  }
}
</style>
